import {getDateParams, getValidDeliveryDate} from './data.helper';
import {URL as CONST_URL} from '../constants/constants';

export const getDeliveryDate = (basket, fulfillmentDetails, settings) => {
  if (basket && basket.fulfillAtSlot && basket.fulfillAtSlot.day) {
    return getValidDeliveryDate(basket.fulfillAtSlot.day);
  } else if (fulfillmentDetails) {
    return getValidDeliveryDate(fulfillmentDetails.date);
  } else if (settings) {
    return getDateParams(basket, settings).deliveryDate;
  }
  return null;
};

export const getPriceMulti = (prices, hasMixOffer) => {
  if (hasMixOffer) {
    return null;
  }
  let finalPrice;
  prices.map(price => {
    if (
      !finalPrice ||
      (finalPrice && price.min && finalPrice.min < price.min)
    ) {
      finalPrice = price;
    }
  });
  return finalPrice;
};

export const getMixAndSaveUrl = (renderMixNSaveTag, promoTagId) => {
  return `/search?${new URLSearchParams({
    adTitle: renderMixNSaveTag,
    q: `offer.promoTagId%3A%28${promoTagId}%29`,
    advanced: true,
  }).toString()}`;
};

const RX = {
  whatsappLink: /(?:https?:\/\/)?(?:wa\.me\/|api\.whatsapp\.com\/send\b)/i,
  whatsappTerm: /\b(?:wa|whatsapp)\b/i,
  phoneLike: /(?:^|[^\w])(?:\+?\d[\d\s\-()]{6,}\d)(?:[^\w]|$)/,
  spamKeyword: /\b(?:szbant\.com|biaya|borongan|plafon|interior|gudang|pintu|transformer|fortress)\b/i,
  manyEncodedBytes: /(?:%[0-9A-Fa-f]{2}){3,}/,
  repeatedSeparators: /[%+_\-]{3,}/,

  // Any non-ASCII character at all, including 【 】 and emojis
  nonAscii: /[^\x20-\x7E]/,

  // Allow only ASCII letters/numbers/space and selected punctuation
  invalidAsciiChars: /[^a-zA-Z0-9\s_\-.,&/()'*:]/,
};

const safeDecodePlus = str => {
  if (!str) return '';
  const replaced = str.includes('+') ? str.replace(/\+/g, ' ') : str;
  try {
    return decodeURIComponent(replaced);
  } catch {
    return replaced;
  }
};

const toUrl = (input, baseUrl = `https://${CONST_URL.JJS_PROD}`) => {
  if (typeof input !== 'string' || input.trim() === '') {
    return null;
  }

  try {
    return new URL(input);
  } catch {
    try {
      return new URL(input, baseUrl);
    } catch {
      return null;
    }
  }
};

export const isPossibleSpamUrl = urlInput => {
  const urlObj = toUrl(urlInput);
  if (!urlObj) return false;

  const queryValue = urlObj.searchParams.get('q') || '';
  const decodedQuery = safeDecodePlus(queryValue);
  const fullUrl = urlObj.href;

  if (RX.whatsappLink.test(fullUrl)) return true;
  if (RX.whatsappTerm.test(decodedQuery) && RX.phoneLike.test(decodedQuery))
    return true;
  if (RX.phoneLike.test(decodedQuery)) return true;
  if (RX.spamKeyword.test(decodedQuery) || RX.spamKeyword.test(fullUrl))
    return true;
  if (RX.manyEncodedBytes.test(fullUrl)) return true;
  if (
    RX.repeatedSeparators.test(queryValue) ||
    RX.repeatedSeparators.test(fullUrl)
  )
    return true;

  // Hard block: any non-ASCII char in q, including 【 】 or emoji
  if (decodedQuery && RX.nonAscii.test(decodedQuery)) return true;

  // Hard block: ASCII chars outside your allowed set
  return !!(decodedQuery && RX.invalidAsciiChars.test(decodedQuery));
};
